import { useContext } from 'react'
import { OrganisationConfigContext } from 'contexts/OrganisationConfig'

export const useOrganisationConfig = () => useContext(OrganisationConfigContext)
